import styled from "styled-components";
import { breakpoints } from "../../../../../constants/media";

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  // Header Bar Open and Close
  .headerBarOpen,
  .headerBarClose {
    width: 92%;
    display: flex;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    padding: 15px 0px 15px 0px;
    background-color: white;
    border: 0;
    cursor: pointer;
    transition: 0.15s ease;
    overflow: hidden;
    border-bottom: 1px solid var(--lightgray2);
  }

  // Header Bar Title
  .headerBarOpen h4,
  .headerBarClose h4 {
    font-size: 16px;
    color: var(--black);
    font-weight: 700;
    margin: 0px 20px 0px 0px;
    text-align: left;
    transition: 0.1s;
  }

  .headerBarOpen h4 {
    color: var(--orange);
  }

  // Header Bar Hover Image
  .headerBarClose:hover
    > .tagImageContainer
    .buttonIconOpenContainer
    #buttonIcon {
    -webkit-transition: 0.3s;
    -moz-transition: 0.3s;
    -ms-transition: 0.3s;
    -o-transition: 0.3s;
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    transform: rotate(180deg);
  }

  // Data Tag and Icon Container
  .tagImageContainer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    align-content: center;
  }

  // Data Tags
  .dataTag {
    margin: 0px 20px 0px 0px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    align-content: center;
  }

  .dataTag p {
    margin: 0px 0px 0px 0px;
    font-size: 0.6em !important;
    letter-spacing: 1px;
    color: var(--lightgray);
  }

  .dataTag span {
    font-size: 1em;
    margin: 0px 6px 0px 0px;
    color: var(--lightgray);
  }

  .completado {
    color: var(--green) !important;
  }

  .error {
    color: var(--red) !important;
  }

  .buttonIconOpenContainer {
    min-width: 18px;
  }

  .ReactCollapse--collapse {
    width: 92%;
  }

  // Text Container
  .displayText {
    width: 100%;
    margin: 0 auto;
    padding: 20px 0px 0px 0px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
    align-content: center;
  }

  .inputsContainer {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-content: flex-start;
    align-items: flex-start;
    margin: 0px 0px 0px 0px;
    padding: 0px 0px 0px 0px;
  }

  // Inputs Container
  .inputContainer {
    width: 47%;
    margin: 0px 0px 20px 0px !important;
  }

  // Input
  .inputContainer input,
  .textAreaContainer textarea {
    width: calc(100% - 32px);
    font-family: Raleway;
    font-style: normal;
    font-weight: normal;
    font-size: 0.75em;
    padding: 0px 15px 0px 15px;
    height: 29px;
    border: 1px solid var(--lightgray);
    transition: all 0.25s ease;
    color: var(--lightgray);
    outline: 0;
    margin: 0px 0px 0px 0px;
    transition: 0.2s all;
    border-radius: 3px;
  }

  #poliza {
    width: 100%;
  }

  .textAreaContainer textarea {
    max-width: calc(100% - 32px);
    min-width: calc(100% - 32px);
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }

  // Labels
  .inputContainer label,
  .textAreaContainer label,
  #selectLabel {
    text-align: left;
    display: block;
    font-family: Raleway;
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    color: var(--black);
    margin: 0px 0px 6px 0px !important;
  }

  .textAreaContainer label {
    margin: 0px 0px 10px 0px !important;
  }

  // Comentario Container
  .comentarioContainer {
    width: 100%;
  }

  // Comentario Input Container
  .comentarioContainer .inputContainer {
    width: 100%;
  }

  // Comentario Input
  .comentarioContainer .textAreaContainer textarea {
    padding: 15px 15px 15px 15px;
    height: 40px;
    min-height: 40px;
    max-height: 40px;
  }

  // Focus
  .inputContainer input:focus,
  .comentarioContainer .textAreaContainer textarea:focus {
    border: 1px solid var(--orange) !important;
  }

  // Tiempo de transicion cuando se abre y se cierra
  .ReactCollapse--collapse {
    transition: height 200ms;
  }

  // 651px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile651}) {
    // Panel
    .panel {
      padding: 0px 0px 6px 0px;
    }

    // Inputs Container
    .inputContainer {
      width: 100%;
      margin: 0px 0px 12px 0px !important;
    }

    .dataTag p {
      display: none;
    }

    .dataTag span {
      margin: 0px;
    }
  }
`;

export default Container;
